
import { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useIsMobile } from "@/hooks/use-mobile";

interface AdminLayoutProps {
  children: ReactNode;
  title: string;
  backLink?: string;
}

export function AdminLayout({ 
  children, 
  title, 
  backLink = "/admin" 
}: AdminLayoutProps) {
  const isMobile = useIsMobile();
  
  return (
    <div className="container mx-auto py-6 px-4 space-y-6">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size={isMobile ? "sm" : "icon"} asChild>
          <Link to={backLink}>
            <ArrowLeft className={isMobile ? "h-4 w-4" : "h-5 w-5"} />
          </Link>
        </Button>
        <h1 className={`font-bold ${isMobile ? "text-xl" : "text-3xl"}`}>{title}</h1>
      </div>
      
      <div className="space-y-6">
        {children}
      </div>
    </div>
  );
}
